// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6177":"e31b88e4080a3299","9650":"5c513c1d74dbef64"}[chunkId] + ".js";
};